import Vue from 'vue'

export default {
    init({ commit, rootState }) {
        return new Promise((resolve, reject) => {
            Vue.axios.get(rootState.url_api + '/permission')
            .then(r => { 
                commit('SET_PERMISSIONS', r.data)
                commit('SET_LOADED_INIT', true)
                resolve(r)
            })
            .catch(r => reject(r))
        })
    },
    init_select({ state, dispatch }) {
        return new Promise((resolve, reject) => {
            if (state.loaded_init === false) {
                dispatch('init')
                .then(r => resolve(r))
                .catch(r => reject(r))
            } else {
                resolve()
            }
        })
    }
}